export default "__VITE_ASSET__d422cc16__"